module.exports = __webpack_public_path__ + "assets/img/whisk.909c6522.png";